import React, { useRef } from 'react';
import { __ } from '../../translations';
import { Modal } from '../ui/Modal';
import { Button, FlexWrapper, FontIcon, Text } from '@intigral/shared';

interface ChangeToKidModePopupProps {
    showPopup?: boolean;
    onClose?: () => void;
}

const ChangeToKidModePopup: React.FC<ChangeToKidModePopupProps> = ({
    showPopup = false,
    onClose = () => {
        ('');
    },
}) => {
    // verifying state
    const popupRef = useRef<HTMLDivElement | null>(null);

    const closePopupHandler = (e?: React.MouseEvent<HTMLAnchorElement>, redirect = false) => {
        if (e && !redirect) e.preventDefault();

        onClose();
    };

    return (
        <Modal
            open={showPopup}
            // useFlexLayout={false}
            onOpenChange={() => {
                closePopupHandler();
            }}
            closePlacement="null"
            widthSet="small"
            body={__('switch_kid_mode')}
            footer={
                <Button
                    primary
                    fullWidth={true}
                    onClick={() => {
                        closePopupHandler();
                    }}
                >
                    Got it
                </Button>
            }
            children={''}
        ></Modal>
    );
};

export default ChangeToKidModePopup;
